import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { ProjetosFormInicialAvulso } from "src/components/projetos/FormInicialAvulso";

const PAGE_TITLE = "Projeto Avulso";

const ProjetoAvulsoPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetosFormInicialAvulso />
        </div>
      </div>
    </div>
  );
};

export { ProjetoAvulsoPage };
